import UITooltip from 'UIComponents/tooltip/UITooltip';
import ContentAssistanceTooltip from 'automation-ui-enrollment/components/aiAssistant/ContentAssistanceTooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const GenerateButtonTooltip = ({
  children,
  hasValidUserInput,
  isContentAssistanceEnabled,
  tooltipTitle
}) => {
  if (!isContentAssistanceEnabled) {
    return /*#__PURE__*/_jsx(ContentAssistanceTooltip, {
      "data-test-id": "generate-actions-disabled-tooltip",
      disabled: isContentAssistanceEnabled,
      children: children
    });
  } else if (!hasValidUserInput) {
    return /*#__PURE__*/_jsx(UITooltip, {
      "data-test-id": "generate-actions-disabled-tooltip",
      title: tooltipTitle,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};
export default GenerateButtonTooltip;